import { FileItem } from '../../file.dto';
import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { InspectionIntegrationDesign } from './inspection-integration-design.dto';
import { IntegrationCommandPost } from './integration-command-post.dto';

export class InspectionIntegrationDto extends InspectionCase {
  integrationDesign?: InspectionIntegrationDesign;
  integrationCommandPost?: IntegrationCommandPost;
  empbededFile?: FileItem;
  empbededFilePages?: string;
  summaryNotes?: SummaryNotes[];
}

export class InspectionIntegration
  extends InspectionIntegrationDto
  implements Inspection
{
  constructor(
    data: InspectionIntegrationDto = {
      title: 'בדיקת משטר הפעלות, מערכת בטיחות אש - אינטגרציה',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);
    this.integrationDesign = new InspectionIntegrationDesign(
      data.integrationDesign
    );
    this.integrationCommandPost = new IntegrationCommandPost(
      data.integrationCommandPost
    );
    this.empbededFile = new FileItem(data.empbededFile);
    this.empbededFilePages = data.empbededFilePages;

    this.summaryNotes = data.summaryNotes;
  }

  setInspectionStatus(): void {
    this.integrationDesign.setInspectionStatus();
    this.integrationCommandPost.setInspectionStatus();
    this.isPassed =
      this.integrationDesign.isPassed && this.integrationCommandPost.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.integrationDesign.getNotes(),
      ...this.integrationCommandPost.getNotes()
    ];
  }

  getCases(): Cases[] {
    return [
      {
        title: this.integrationDesign.title,
        cases: [
          this.integrationDesign.documents,
          this.integrationDesign.riskLevel,
          this.integrationDesign.structureDescription,
          this.integrationDesign.areas
        ]
      },
      {
        title: this.integrationCommandPost.title,
        cases: [
          this.integrationCommandPost.dialRiskLevel,
          this.integrationCommandPost.commandPostLocation,
          this.integrationCommandPost.commandPostParts,
          this.integrationCommandPost.installedSystems,
          this.integrationCommandPost.performedActions,
          this.integrationCommandPost.manualActions
        ]
      },
      { title: 'משטר ההפעלות שנבדקו', cases: [{ title: 'משטר ההפעלות' }] }
    ];
  }
}
